import { useEffect, useRef } from "react";
import pushService from "../services/PushService";

/**
 * React hook for subscribing to Pusher events
 * @param {string} channelName - Channel name
 * @param {string} eventName - Event name
 * @param {Function} callback - Callback function when event is received
 */
export function usePusher(channelName, eventName, callback) {
	const unbinderRef = useRef(null);

	useEffect(() => {
		// Only bind if we have both channel and event names
		if (channelName && eventName && callback) {
			const eventPath = `${channelName}/${eventName}`;
			unbinderRef.current = pushService.bind(eventPath, callback);

			return () => {
				// Cleanup subscription when component unmounts
				if (unbinderRef.current) {
					unbinderRef.current();
					unbinderRef.current = null;
				}
			};
		}
	}, [channelName, eventName, callback]);
}
